import { render } from "./indexUserComponent.vue?vue&type=template&id=4380284b"
import script from "./indexUserComponent.vue?vue&type=script&lang=js"
export * from "./indexUserComponent.vue?vue&type=script&lang=js"

import "./indexUserComponent.vue?vue&type=style&index=0&id=4380284b&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__